// extracted by mini-css-extract-plugin
module.exports = {"page":"skeletonLoader_page__2FsqY","shimmer":"skeletonLoader_shimmer__HqyJO"};